import React from 'react'

import { useLuminaireActiveAlerts } from '../../hooks/useLuminaireMetrics'
import ProfessionalChartLoader from '../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { LuminaireMetricFilter } from '../../types/luminaire.types'
import { Point } from '../../../Jouly/types/types'

interface Props {
  devEui: string
  filter: LuminaireMetricFilter
}

export default function LuminaireActiveAlertsCardPresenter({ devEui, filter }: Props) {
  const { data, isLoading, isError } = useLuminaireActiveAlerts(devEui, filter)

  if (isLoading) {
    return <ProfessionalChartLoader metricName="Alertes actives" />
  }

  if (isError) {
    return <ChartErrorView metricName="Alertes actives" />
  }

  const points: Point[] = data ?? []
  const activeAlerts = points
    .filter((p) => p.Value !== 0)
    .map((p) => p.Field || p.Measurement)

  return (
    <div>
      <div style={{ fontSize: 12, color: '#888888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
        Alertes actives (24h)
      </div>
      {activeAlerts.length === 0 ? (
        <div style={{ color: '#22c55e', fontSize: 14, fontWeight: 500 }}>
          Aucune alerte active
        </div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
          {activeAlerts.map((alert, i) => (
            <span
              key={i}
              style={{
                background: '#ef4444',
                color: '#ffffff',
                borderRadius: 4,
                padding: '2px 10px',
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              {alert}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
